import React from "react";
import { Link } from "react-router-dom";
import { FOOTER_DIRECTORY } from "../data/ecosystemData";
import indexxLogo from "../../../assets/header-icons/indexx-logo-v3-dark.svg";

export const Footer: React.FC = () => {
  return (
    <footer className="homepage1-footer">
      <div className="homepage1-footer-inner">
        {/* Multi-Column Directory Grid */}
        <div className="homepage1-footer-grid">
          {/* Brand Column */}
          <div className="homepage1-footer-brand-col">
            <div className="homepage1-footer-logo-title">
              <Link to="/" className="homepage1-footer-brand-link">
                <img
                  src={indexxLogo}
                  alt="indexx.ai"
                  className="homepage1-footer-logo"
                />
              </Link>
            </div>
            <p className="homepage1-footer-desc">
              The Unified Ecosystem of AI &amp; Crypto. Orchestrating
              decentralized trading, autonomous agent intelligence, synthetic
              instruments, and verifiable vault systems.
            </p>
            <div className="homepage1-footer-status">
              Status: <span>Mainnet Operational</span>
            </div>
          </div>

          {/* Column: Platform */}
          <div>
            <h4 className="homepage1-footer-col-title">Platform</h4>
            <ul className="homepage1-footer-list">
              {FOOTER_DIRECTORY.platform.map((item, idx) => (
                <li key={idx}>
                  {item.url.startsWith("http") ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link to={item.url}>{item.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Column: Products */}
          <div>
            <h4 className="homepage1-footer-col-title">Products</h4>
            <ul className="homepage1-footer-list">
              {FOOTER_DIRECTORY.products.map((item, idx) => (
                <li key={idx}>
                  {item.url.startsWith("http") ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link to={item.url}>{item.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Column: Program & Wallet */}
          <div>
            <h4 className="homepage1-footer-col-title">Program</h4>
            <ul className="homepage1-footer-list" style={{ marginBottom: "1.25rem" }}>
              {FOOTER_DIRECTORY.program.map((item, idx) => (
                <li key={idx}>
                  <Link to={item.url}>{item.label}</Link>
                </li>
              ))}
            </ul>
            <h4 className="homepage1-footer-col-title">Wallet</h4>
            <ul className="homepage1-footer-list">
              {FOOTER_DIRECTORY.wallet.map((item, idx) => (
                <li key={idx}>
                  <Link to={item.url}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column: Company */}
          <div>
            <h4 className="homepage1-footer-col-title">Company</h4>
            <ul className="homepage1-footer-list">
              {FOOTER_DIRECTORY.company.map((item, idx) => (
                <li key={idx}>
                  <Link to={item.url}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar: Minimal Understated Text */}
        <div className="homepage1-footer-bottom">
          <p className="homepage1-footer-copyright">
            Copyright &copy; {new Date().getFullYear()} indexx.ai All Rights Reserved.
          </p>
          <div className="homepage1-footer-legal-links">
            <Link to="/indexx-exchange/legal/privacypolicy">Privacy Policy</Link>
            <Link to="/indexx-exchange/legal/termsandconditions">Terms of Use</Link>
            <Link to="/indexx-exchange/legal">Legal</Link>
            <Link to="/indexx-exchange/how-it-works">Architecture</Link>
            <Link to="/indexx-exchange/help">Docs</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
